import * as React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { DMButton, DMDiv, DMImage } from './Primitives';

type ImagePreviewModalProps = {
  imageUrl: string;
  alt?: string;
  onClose: () => void;
  showNaturalSize?: boolean;
};

export const ImagePreviewModal = ({
  imageUrl,
  alt = 'Selected image preview',
  onClose,
  showNaturalSize = false,
}: ImagePreviewModalProps) => {
  if (!imageUrl) {
    return null;
  }

  return createPortal(
    <DMDiv className="fixed inset-0 z-[10003] flex items-center justify-center bg-black/60 px-[1vw] py-[1.5vh]">
      <DMButton
        type="button"
        className="absolute inset-0 cursor-default"
        onClick={onClose}
        aria-label="Close image preview backdrop"
      />
      <DMDiv
        className={`relative z-10 flex max-h-[97vh] max-w-[98vw] rounded-[10px] bg-white p-[0.8vh] shadow-[0_18px_45px_rgba(0,0,0,0.35)] ${
          showNaturalSize
            ? 'items-start justify-start overflow-auto'
            : 'items-center justify-center'
        }`}
      >
        <DMButton
          type="button"
          onClick={onClose}
          className="absolute right-[1vh] top-[1vh] z-20 flex h-[4vh] min-h-[4vh] w-[4vh] min-w-[4vh] items-center justify-center rounded-full bg-white p-0 text-gray-800 shadow-[0_4px_12px_rgba(0,0,0,0.18)] hover:bg-gray-100"
          aria-label="Close image preview"
        >
          <X className="h-[2.3vh] w-[2.3vh]" strokeWidth={2.3} />
        </DMButton>
        <DMImage
          src={imageUrl}
          alt={alt}
          className={`${
            showNaturalSize
              ? 'h-auto w-auto max-w-none'
              : 'max-h-[95vh] max-w-[96vw] object-contain'
          } rounded-[8px]`}
        />
      </DMDiv>
    </DMDiv>,
    document.body,
  );
};
